import api from './api';
import { jwtDecode } from 'jwt-decode';

// Login de usuário
const login = async (email, senha) => {
  const response = await api.post('/auth/login', { email, senha });

  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.usuario));
  }

  return response.data;
};

// Logout de usuário
const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Obter usuário atual
const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

// Verificar se o usuário está autenticado
const isAuthenticated = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Verificar se o token não expirou
    return decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
};

// Verificar se o usuário tem uma permissão específica
const hasPermission = permission => {
  const user = getCurrentUser();

  if (!user || !user.permissoes) {
    return false;
  }

  // Administrador tem todas as permissões
  if (user.cargo === 'admin') {
    return true;
  }

  return user.permissoes[permission] === true;
};

// Verificar token
const verificarToken = async () => {
  try {
    const response = await api.get('/auth/verificar');
    return response.data;
  } catch (error) {
    throw error;
  }
};

const authService = {
  login,
  logout,
  getCurrentUser,
  isAuthenticated,
  hasPermission,
  verificarToken,
};

export default authService;
